import React, { useState, useContext } from "react";

const ScreenWidthContext = React.createContext({});
const { Provider } = ScreenWidthContext;

const useInitialLoad = () => {
  const context = useContext(ScreenWidthContext);
  if (context === undefined) {
    throw new Error("useInitialLoad must be used within a InitialLoadProvider");
  }
  return context;
};

const InitialLoadProvider = ({ children }) => {
  const [firstTimeLoaded, setFirstTimeLoaded] = useState(false);

  return (
    <Provider value={{ firstTimeLoaded, setFirstTimeLoaded }}>
      {children}
    </Provider>
  );
};

export { InitialLoadProvider, useInitialLoad };
